import { useMutation, useQuery } from '@tanstack/react-query';
import { generatePublicSentimentKeywords, generateSSOToken, getPublicDefaultSentimentKeywords } from './apis';
import { SentimentKeywordsResponse } from './types';

export const useGenerateSSOToken = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['generateSSOToken'],
    queryFn: generateSSOToken,
    enabled
  });
};

export function useGetPublicDefaultSentimentKeywords(enabled: boolean = true) {
  return useQuery<SentimentKeywordsResponse>({
    queryKey: ['publicSentimentKeywords', 'default'],
    queryFn: () => getPublicDefaultSentimentKeywords(),
    enabled
  });
}

export function useGeneratePublicSentimentKeywords() {
  return useMutation({
    mutationFn: (text: string) => generatePublicSentimentKeywords(text)
  });
}
